var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSlidersGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.0002 27L32.0003 54",
    stroke: "#677791",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0003 10L32.0002 17",
    stroke: "#677791",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0002 27C34.7617 27 37.0002 24.7614 37.0002 22C37.0002 19.2386 34.7617 17 32.0002 17C29.2388 17 27.0002 19.2386 27.0002 22C27.0002 24.7614 29.2388 27 32.0002 27Z",
    stroke: "#677791",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0002 47L50.0005 54",
    stroke: "#677791",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0005 10L50.0002 37",
    stroke: "#677791",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0002 47C52.7617 47 55.0002 44.7614 55.0002 42C55.0002 39.2386 52.7617 37 50.0002 37C47.2388 37 45.0002 39.2386 45.0002 42C45.0002 44.7614 47.2388 47 50.0002 47Z",
    stroke: "#677791",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0002 39L14.0001 54",
    stroke: "#677791",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0001 10L14.0002 29",
    stroke: "#677791",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0002 39C16.7617 39 19.0002 36.7614 19.0002 34C19.0002 31.2386 16.7617 29 14.0002 29C11.2388 29 9.00024 31.2386 9.00024 34C9.00024 36.7614 11.2388 39 14.0002 39Z",
    stroke: "#677791",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlidersGrey);
export default __webpack_public_path__ + "static/media/SlidersGrey.73c97733aafcfb56b4279f738da44d02.svg";
export { ForwardRef as ReactComponent };